<template>
    <div class="mb4 col-xs-8 col-sm-4 col-md-3 col-lg-2 center">
        <slot></slot>
        <h6 class="mt2">{{title}}</h6>
        <div class="bodyCopy">{{description}}</div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        }
    }
};
</script>
